import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import UserMenu from "apps/messenger/containers/UserMenu";

import ScaleFadeTransition from "shared/components/ScaleFadeTransition";
import Link from "shared/components/Link";
import UserRow from "shared/components/UserRow";
import isSpa from "shared/util/isSpa";
import { isMobile } from "shared/util/EnvironmentHelpers";
import { isStandalonePage } from "apps/messenger/util/helpers";

import "apps/messenger/components/shared/MessengerUserRow/index.scss";

const MessengerUserRow = ({
	className,
	onOpen,
	onMinimize,
	onClose,
	showUserMenuButton,
	goBack,
	...user
}) => {
	const userid = user.userid;
	const userinfo = user.userinfo || {};
	const isOkCupidUser = userid === "0";

	const _handleOpen = onOpen ? () => onOpen(userid) : undefined;
	const Wrapper = onOpen ? "button" : Link;
	const wrapperProps = onOpen ? {
		onClick: _handleOpen,
	} : {
		to: `/profile/${userid}?cf=messenger`,
		target: isStandalonePage ? "_blank" : undefined,
		noSpa: !isSpa(),
	};
	const showBackButton = isMobile && goBack;

	return (
		<div className={classnames("messenger-user-row", className, {
			"messenger-user-row--has-back-button": showBackButton,
		})}>
			{showBackButton && (
				<button className="messenger-user-row-back" onClick={goBack}>
					<span className="icon i-arrow-left" />
				</button>
			)}
			<Wrapper
				className={classnames("messenger-user-row-main", {
					"messenger-user-row-main--toggle": !!onOpen,
				})}
				{...wrapperProps}
			>
				<UserRow
					{...user}
					userinfo={{
						...userinfo,
						location: null,
						age: null,
					}}
					location={null}
					percentages={null}
					likes={{}}
					last_contacts={{}}
					displayType={showBackButton
						? UserRow.displayTypes.SmallRowVerical
						: UserRow.displayTypes.SmallRow}
					shouldDisableAnimationLikes
					shouldDisablePopover
					showInactive
				/>
			</Wrapper>
			<ScaleFadeTransition>
				{onOpen && user.unreadCount > 0 && (
					<button className="messenger-user-row-badge" onClick={_handleOpen}>
						{user.unreadCount}
					</button>
				)}
			</ScaleFadeTransition>
			{!isOkCupidUser && showUserMenuButton && (
				<UserMenu userid={userid}>
					{(toggleUserMenu) => (
						<button className="messenger-user-row-menu" onClick={toggleUserMenu}>
							<span className="icon i-ellipsis-v" />
						</button>
					)}
				</UserMenu>
			)}
			{onMinimize && (
				<button className="messenger-user-row-minimize" onClick={() => onMinimize(userid)}>
					<span className="icon i-minimize" />
				</button>
			)}
			{onClose && (
				<button className="messenger-user-row-close" onClick={() => onClose(userid)}>
					<span className="icon i-close" />
				</button>
			)}
		</div>
	);
};

MessengerUserRow.propTypes = {
	className: PropTypes.string,
	onOpen: PropTypes.func,
	onMinimize: PropTypes.func,
	onClose: PropTypes.func,
	goBack: PropTypes.func,

	showUserMenuButton: PropTypes.bool,
};

MessengerUserRow.defaultProps = {
	className: undefined,
	onOpen: null,
	onMinimize: null,
	onClose: null,
	goBack: null,

	showUserMenuButton: false,
};

export default MessengerUserRow;



// WEBPACK FOOTER //
// ./src/apps/messenger/components/shared/MessengerUserRow/index.jsx